import React from 'react';
import styled from 'styled-components';

import { Link } from '@reach/router';

const StyledFooterContainer = styled.footer`
  position: absolute;
  bottom: 0;
  min-height: 1vh;
  width: 100%;
  font-family: ${({ theme }) => theme.fonts.main};
  font-size: 13px;
  color: #666;
  text-align: center;
  padding: ${({ theme }) => theme.spacingBase} 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  a,
  a:hover,
  a:visited {
    color: #222;
    margin: 0 5px;
  }
`;

const Credit = styled.span`
  margin-left: ${({ theme }) => theme.spacingBase};
  a,
  a:hover,
  a:visited {
    margin: 0;
  }
`;

const Copyright = styled.span`
  margin-right: ${({ theme }) => theme.spacingBase};
`;
export default function Header() {
  return (
    <StyledFooterContainer>
      <Copyright>&copy; Copyright Leanloop Ltd.</Copyright>
      <Link to="/privacy">privacy policy</Link>
      <Link to="/terms">terms and conditions</Link>
      <Link to="/cookies">cookie policy</Link>
      <a href="https://twitter.com/agilyticsapp">twitter</a>
      <Credit>
        illustration by{' '}
        <a href="https://icons8.com" target="_blank" rel="noopener noreferrer">
          Ouch.pics
        </a>
      </Credit>
    </StyledFooterContainer>
  );
}
